<template>
    <div class="Page">
        <Header Act="0"></Header>
        <div class="MaxWid">
            <!-- <div class="Logo">
                <div class="LogoImg">
                    <img src="../../assets/img/logo.jpg" alt="">
                    <div class="LogoTxt">
                        <p>中国心理卫生协会</p>
                        <p>China Association for Mental Health</p>
                    </div>
                </div>
            </div> -->
            <div class="LoginDis">
                <div class="LoginImg">
                    <img src="../../assets/img/login.png" alt="">
                </div>
                <div class="LoginCont">
                    <div class="LoginTit">欢迎登录</div>
                    <div class="LoginNav">
                        <div class="LoginNavItem" :class="{Act:i==1}" @click="ToggleNav(1)">密码登录</div>
                        <div class="LoginNavItem" :class="{Act:i==2}" @click="ToggleNav(2)">验证码登录</div>
                    </div>
                    <div class="LoginItem">
                        <div class="LoginItemMsg">手机号</div>
                        <div class="LoginItemVal">
                            <input type="text" v-if="i==1" v-model="SetData.account" placeholder="请输入手机号">
                            <input type="text" v-if="i==2" v-model="SetData.mobile" placeholder="请输入手机号">
                        </div>
                    </div>
                    <div class="LoginItem">
                        <div class="LoginItemMsg">{{i==1?'密码':'验证码'}}</div>
                        <div class="LoginItemVal">
                            <input type="password" v-if="i==1" v-model="SetData.password">
                            <input type="password" v-if="i==2" v-model="SetData.captcha">
                            <div class="LoginItemCode" v-if="i==2" :class="{BgGary:CountTime!=60}" @click="GetCode">{{ShowTime}}</div>
                        </div>
                    </div>
                    <div class="LoginBtn" @click="LoginSuc">登录</div>
                    <div class="LoginOther">
                        <div class="ColorBlue" @click="GoPage('/Reg')">免费注册</div>
                        <div @click="GoPage('/Retrieve')">忘记密码？</div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/header/head';
    import Footer from '@/components/header/footer';
    export default {
        components: {Header,Footer},
        data() {
            return {
                i:1,
                SetData:{},
                CountTime:60,
                DomTime:"",
                ShowTime:"获取验证码",
            }
        },
        mounted() {
            // this.GetChart();
        },
        methods: {
            ToggleNav(i){
                this.i=i
            },
            LoginSuc(){
                var Quy  = JSON.parse(JSON.stringify(this.SetData));
                var Url = 'api/user/login';
                if(this.i == 2){
                    Url = 'api/user/mobilelogin';
                }
                this.$post(Url,Quy).then((res) => {
                    if (res.data.code == 1) {
                        localStorage.setItem("User", JSON.stringify(res.data.data));
                        this.$message({ message: res.data.msg, type: 'success' });
                        this.GoPage('/')
                    }else{
                        this.$message({ message: res.data.msg, type: 'error' });
                    }
                })
            },
            GetCode(phone){
                if(this.ShowTime == "获取验证码"){
                    if(this.$Global.isPhone(this.SetData.mobile) ){
                          this.$post('api/sms/xinxie_send', {
                              mobile: this.SetData.mobile,
                              event:"mobilelogin",
                          }).then((res) => {
                              if (res.data.code == 1) {
                                  this.$message({ message: res.data.msg, type: 'success' });
                                  this.ShowTime = this.CountTime+"s";
                                  this.CountTime--;
                                  this.DomTime = setInterval(() =>{
                                      if (this.CountTime == 0) {
                                          clearInterval(this.DomTime);
                                          this.ShowTime = "获取验证码"
                                          this.CountTime = 60;
                                      } else {
                                          this.ShowTime = this.CountTime+"s";
                                          this.CountTime--;
                                      }
                                  },1000)
                              }
                          })
                    }else{
                        this.$message({ message: '请输入正确的手机号', type: 'error' });
                    }
                }
            },
            //跳转
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
        },
    }
</script>
<style scoped>
    .Page {
        background: #fff;
    }
    .Logo{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 10px;
    }
    .LogoImg{
        display: flex;
        align-items: center;
        flex: 1;
    }
    .LogoImg img{
        width: 60px;
        margin-right: 20px;
    }
    .LogoTxt{
        line-height: 24px;
    }
    .MaxWid {
        max-width: 1080px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .LoginDis{
        margin: 50px 0;
        display: flex;
    }
    .LoginImg img{
        width: 450px;
        height: 450px;
    }
    .LoginCont{
        flex: 1;
        margin-left: 10%;
    }
    .LoginTit{
        margin-bottom: 60px;
        font-weight: 400;
        font-size: 30px;
        color: #555;
        text-align: center;
    }
    .LoginNav{
        display: flex;
        align-items: center;
        margin: 20px 0;
    }
    .LoginNavItem{
        flex: 1;
        padding: 10px 0;
        text-align: center;
        border-bottom: 1px solid #ccc;
        font-weight: 400;
        font-size: 20px;
        color: #666666;
        cursor: pointer;
    }
    .LoginNavItem:hover,
    .LoginNavItem.Act{
        background: #0385EB;
        color: #fff;
    }
    .LoginItem{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    .LoginItemMsg{
        width: 50px;
        color: #666666;
        font-size: 16px;
        text-align: right;
    }
    .LoginItemMsg{
        padding: 15px 0;
    }
    .LoginItemVal{
        display: flex;
        align-items: center;
        border: 1px solid #ccc;
        flex: 1;
        margin-left: 20px;
    }
    .LoginItemVal input{
        padding: 15px;
        flex: 1;
    }
    .LoginItemVal .LoginItemCode{
        width: 200px;
        padding: 13px 0;
        color: #fff;
        background: #0385EB;
        text-align: center;
        cursor: pointer;
    }
    .LoginItemVal .LoginItemCode.BgGary{
        color: #fff;
        background: #bcbcbc;
        cursor: no-drop;
    }
    .LoginBtn{
        margin-top: 40px;
        padding: 15px 0;
        color: #fff;
        background: #0385EB;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
    }
    .LoginOther{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #666;
        font-size: 16px;
        margin-top: 10px;
    }
    .LoginOther div{
        cursor: pointer;
    }
    .LoginOther .ColorBlue{
        color: #0385EB;
    }
    @media only screen and (max-width: 536px) {
       .LoginDis{
           display: block;
       }
       .LoginImg{
           display: none;
       }
       .LoginCont{
           margin: 0;
       }
       .LoginItemVal .LoginItemCode{
           width: 100px;
       }
    }
</style>